import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        downloadJpg: {
          FOOTER: 'Source: FiinGate Platform',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        downloadJpg: {
          FOOTER: 'Nguồn: Nền tảng FiinGate',
        },
      },
    },
  }),
)
